<template>
  <div class="pe-option-container">
    <SearchableSelect :options="selectOptions" :disabledItems="isMultiple ? selectedItems : []"
      :selected="selectedItems" :filter-keys="['title']" placeholderKey="title"
      :defaultPlaceholder="computedPlaceholder" @select="handleSelect" />

    <div v-if="isMultiple && selectedItems.length > 0" class="pe-ListOptions">
      <div v-for="opt in selectedItems" :key="opt.id" @click="removeItem(opt)" class="pe-ListItem">
        <p :class="[globalConfig.classes?.input]">{{ opt.title }}</p>
        <span class="pe-delete-icon">✕</span>
      </div>
    </div>

  </div>
</template>

<script setup>
import { computed, inject } from 'vue';
import SearchableSelect from '../Shared/SearchableSelect.vue';

const props = defineProps({
  question: { type: Object, required: true },
});

const engine = inject('formEngine');
const globalConfig = inject('engineConfig');

// 1. Opciones disponibles (vienen del grupo 'select' generado por el Engine)
const selectOptions = computed(() => {
  return props.question.optionGroups['select'] || [];
});

// 2. Elementos Seleccionados (Calculado en base a si tienen valor en el engine)
const selectedItems = computed(() => {
  return selectOptions.value.filter(opt => opt.value !== null && opt.value !== undefined);
});

// 3. Helper para saber si es múltiple
const isMultiple = computed(() => props.question.allow_multiple_answers);

// 4. Placeholder Dinámico (La lógica "useLastAsPlaceHolder")
const computedPlaceholder = computed(() => {
  // Si es múltiple, texto genérico
  if (isMultiple.value) {
    return selectedItems.value.length > 0
      ? 'Seguí seleccionando...'
      : 'Seleccioná las opciones que correspondan';
  }

  // Si es single, mostramos el título del seleccionado o el default
  const selected = selectedItems.value[0];
  return selected ? selected.title : 'Seleccioná una opción';
});

// 5. Manejadores
const handleSelect = (item) => {
  engine.setAnswer(props.question.id, item.id, item.title);
};

const removeItem = (item) => {
  // Para borrar, enviamos null
  engine.setAnswer(props.question.id, item.id, null);
};
</script>

<style scoped>
.pe-ListOptions {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* Importante por si son muchos */
  width: 100%;
  gap: var(--pe-qo-select-list-gap, 1.5vh);
  margin: var(--pe-qo-select-list-margin, 0);
}

.pe-ListItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: none;
  background: #f5f5f5;
  border-radius: var(--pe-input-border-radius, 0.5rem);
  /* Un poco más standard */
  padding: var(--pe-qo-select-list-item-padding, 0.75vw);
  cursor: pointer;
  gap: var(--pe-options-gp, 1.5vh);

  background: var(--pe-selected-item-bg, #F5F5F5);
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
  transition: background 0.2s;
}

.pe-ListItem:hover {
  background: var(--pe-selected-item-hover-bg, #e0e0e0);
}

.pe-ListItem p {
  margin: 0;
  color: var(--pe-input-text-color, #333);
}

.pe-delete-icon {
  font-weight: bold;
  color: var(--pe-delete-icon-color, #666);
}

.pe-delete-icon:hover {
  color: var(--pe-error-color, #ff4d4f);
}
</style>